import api from "./api.ts";

class minigameRequests {
    async addTurn(orderNumber: string) {
        return await api.post('/Minigame/AddTurn', {orderNumber: orderNumber})
    }

    // Quay vòng quay và lấy kết quả
    async spin() {
        return await api.get('/Minigame/Spin')
    }

    async getGifts(mingameName: string) {
        return await api.get('/Minigame/GetGifts?MinigameCode=' + mingameName);
    }

    async getPieces() {
        return await api.get('/Minigame/GetPieces');
    }

    async getRewards(mingameName: string, page: number = 1, pageSize: number = 10) {
        return await api.get(`/Minigame/GetRewards?MinigameCode=${mingameName}&pageNumber=${page}&pageSize=${pageSize}`);
    }

    async openPuzzle() {
        return await api.get('/Minigame/OpenPuzzle')
    }

    async getPuzzleHistory(page: number = 1, pageSize: number = 10) {
        return await api.get(`/Minigame/GetPuzzleHistory?pageNumber=${page}&pageSize=${pageSize}`);
    }

    async getAddTurnHistory(orderNumber: string | null, page: number = 1, pageSize: number = 10) {
        return await api.get(`/Minigame/getAddTurnHistory?keyword=${orderNumber}&pageNumber=${page}&pageSize=${pageSize}`);
    }
}

export default new minigameRequests();
